import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Header from '../../header';
import Footer from '../../footer';
import styles from '@/styles/Template.module.css';
import ServiceManagementAutomatic from '@/pages/images/serviceManagementAutomatic';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from "swiper";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import RightArrow from '@/pages/images/rightArrow';
import StepSecond from '@/pages/images/stepSecond';
import StepThird from '@/pages/images/stepThird';
import StepFirst from '@/pages/images/stepFirst';
import Image, { ImageLoaderProps } from 'next/image';
import { IMAGE_DELIVERY, imageLoader } from "@/base/utils/dataHelper";
import PageSeo from '@/components/seo/PageSeo';

const ProblemManagement = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const isLanguage = router.locale?.toUpperCase().toString();

  type PreviewTab = 'form' | 'workflow';
  const [activePreviewTab, setActivePreviewTab] = useState<PreviewTab>('form');

  return (
    <>
      <PageSeo title={`${t("problemManagement")} | Stoneity`} description={t("problemManagementOverview")} locale={router.locale} />
      <Header />
      <div className={styles.mainFlex}>
        <div className={styles.templateBannerBackground}>
          <div className={styles.templateBannerWrapper}>
            <div className={styles.templateBannerLeft}>
              <div className={styles.templateBannerTitle}>{t("convertRecurringIncidents")}</div>
              <div className={styles.templateBannerDescription}>{t("linkRelatedIncidents")}</div>
            </div>
            <div className={styles.circleContent}>
              <div className={styles.circleBackground}></div>
              <div className={styles.circleRing}><span className={styles.ring}></span></div>
              <div className={styles.circleUserWrapper}>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-6.png" alt="" />
                  </div>
                  {t("projectManagementText")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-4.png" alt="" />
                  </div>
                  {t("taskManagement")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-2.png" alt="" />
                  </div>
                  {t("operations")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-5.png" alt="" />
                  </div>
                  {t("portfolio")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-3.png" alt="" />
                  </div>
                  {t("salesAndCRM")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-1.png" alt="" />
                  </div>
                  {t("marketing")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pageFlex}>
          <div className={styles.templateInfoWrapper}>
            <div className={styles.textWrapperFlex}>
              <div className={styles.textWrapper}>
                <div className={styles.title}>{t("problemManagement")}</div>
                <div className={styles.description}>{t("problemManagementOverview")}</div>
              </div>
            </div>
            <div className={styles.templateInfoBottom}>
              <div className={styles.templateInfoLeft}>
                <div className={`${styles.templateInfoTextWrapper} ${activePreviewTab === 'form' ? styles.templateInfoTextWrapperActive : ""}`} onClick={() => setActivePreviewTab('form')}>
                  <div className={styles.templateInfoTitle}>
                    {t("form")}
                    <RightArrow />
                  </div>
                  {/* <div className={styles.templateInfoDescription}>
                    sdafkjasldkfjaklş
                  </div> */}
                </div>
                <div className={`${styles.templateInfoTextWrapper} ${activePreviewTab === 'workflow' ? styles.templateInfoTextWrapperActive : ""}`} onClick={() => setActivePreviewTab('workflow')}>
                  <div className={styles.templateInfoTitle}>
                    {t("workflowText")}
                    <RightArrow />
                  </div>
                  {/* <div className={styles.templateInfoDescription}>
                    asdkfjşkladsjfasdlşk
                  </div> */}
                </div>
              </div>
              <div className={styles.templateInfoRight}>
                {activePreviewTab === 'form' && (
                  <Image
                    className={styles.templateInfoRightImg}
                    src={isLanguage === "TR" ? `${IMAGE_DELIVERY}/f7799eaf-67bc-4ff0-6185-08191aa1c700` : `${IMAGE_DELIVERY}/66f0a3dc-ee8c-49e3-6692-47b678faa300`}
                    alt={""}
                    width={640}
                    height={894}
                    loader={(p: ImageLoaderProps) => imageLoader(p.src, 640, 894)}
                  />
                )}
                {activePreviewTab === 'workflow' && (
                  <Image
                    className={styles.templateInfoRightImg}
                    src={isLanguage === "TR" ? `${IMAGE_DELIVERY}/f3c0eca6-902d-47bb-b307-ac4ec46f6a00` : `${IMAGE_DELIVERY}/efee0ebc-9274-476e-5085-ef52530b7400`}
                    alt={""}
                    width={460}
                    height={640}
                    loader={(p: ImageLoaderProps) => imageLoader(p.src, 460, 640)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pageFlex}>
          <div className={styles.howToWrapper}>
            <div className={styles.textWrapper}>
              <div className={styles.title}>{t("howToImplementSolutions")}</div>
              {/* <div className={styles.description}>{t("manageServiceDisruptions")}</div> */}
            </div>
            <div className={styles.howToCardWrapper}>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepFirst />
                  <div className={styles.howToCardTitle}>{t("createRcaTemplate")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("standardizeAnalysisSteps")}</div>
              </div>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepSecond />
                  <div className={styles.howToCardTitle}>{t("publishKnowledge")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("publishKnownErrorWorkaround")}</div>
              </div>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepThird />
                  <div className={styles.howToCardTitle}>{t("reduceRecurrence")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("proactiveWithTrendAnalysis")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])),
  },
});

export default ProblemManagement;
